import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'callduration',
    standalone: false
})

export class callDurationPipe implements PipeTransform {
    transform(sec: any): any {
        if (sec == '-1') {
            sec = 0;
          }
          var hrs = Math.floor(sec / 3600);
          var min = Math.floor((sec - (hrs * 3600)) / 60);
          var seconds = sec - (hrs * 3600) - (min * 60);
          seconds = Math.round(seconds * 100) / 100;
          var result = (hrs < 10 ? "0" + hrs : hrs);
          result += ":" + (min < 10 ? "0" + min : min);
          result += ":" + (seconds < 10 ? "0" + seconds : seconds);
          return result;
    }
}